var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "automation-user-permission-row",
      class: {
        "row-odd": _vm.isOdd,
        inactive: !_vm.isActive,
        "blur-row": !_vm.isActive,
        "current-user-row": _vm.isCurrentUser,
      },
    },
    [
      _c(
        "div",
        { staticClass: "target-cell" },
        [
          _c("div", { staticClass: "target-info" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
            _vm._v(" "),
            _c("span", { staticClass: "target-name" }, [
              _vm._v(_vm._s(_vm.user.name)),
            ]),
            _vm._v(" "),
            _vm.isCurrentUser
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          content: _vm.$t(
                            "automation.permissions.cannotChangeOwnPermission"
                          ),
                        },
                        expression:
                          "{ content: $t('automation.permissions.cannotChangeOwnPermission') }",
                      },
                    ],
                    staticClass: "current-user-badge",
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("account_circle"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("automation.permissions.you")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm.hasUserOverride
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          content: _vm.$t(
                            "automation.permissions.customPermissionDefined"
                          ),
                        },
                        expression:
                          "{ content: $t('automation.permissions.customPermissionDefined') }",
                      },
                    ],
                    staticClass: "override-badge",
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("verified_user"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("automation.permissions.customPermission")
                        ) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.isActive && !_vm.isCurrentUser
            ? _c("SupsisButton", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("automation.permissions.grantPermission"),
                    },
                    expression:
                      "{ content: $t('automation.permissions.grantPermission') }",
                  },
                ],
                attrs: { ghost: "", primary: "", icon: "add", small: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("activate", _vm.user._id)
                  },
                },
              })
            : _vm.isActive && !_vm.isCurrentUser
            ? _c("SupsisButton", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t(
                        "automation.permissions.revokePermission"
                      ),
                    },
                    expression:
                      "{ content: $t('automation.permissions.revokePermission') }",
                  },
                ],
                attrs: {
                  ghost: "",
                  danger: "",
                  icon: "remove_circle",
                  small: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("deactivate", _vm.user._id)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.scopeGroups, function (group) {
        return _c("div", { key: group.id, staticClass: "scope-group-cell" }, [
          _c(
            "div",
            { staticClass: "scope-toggles" },
            _vm._l(group.scopes, function (scope) {
              return _c(
                "div",
                {
                  key: scope,
                  staticClass: "scope-toggle-cell",
                  class: {
                    "root-cell": _vm.isCurrentUser,
                  },
                  on: {
                    click: function ($event) {
                      !_vm.isCurrentUser &&
                        _vm.isActive &&
                        _vm.toggleScope(scope)
                    },
                  },
                },
                [
                  _c(
                    "SupsisButton",
                    {
                      class: { "scope-active": _vm.hasScope(scope) },
                      attrs: { disabled: !_vm.isActive || _vm.isCurrentUser },
                    },
                    [
                      _vm.hasScope(scope)
                        ? _c("i", { staticClass: "material-icons" }, [
                            _vm._v("done"),
                          ])
                        : _c(
                            "div",
                            {
                              staticClass: "disabled-item",
                              on: {
                                mouseenter: function ($event) {
                                  _vm.isActive && _vm.hoverEffect($event, true)
                                },
                                mouseleave: function ($event) {
                                  _vm.isActive && _vm.hoverEffect($event, false)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("done"),
                              ]),
                              _vm._v(" "),
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("circle"),
                              ]),
                            ]
                          ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }